import produce from 'immer'
import { CardspartnersAction, CardspartnersActionTypes } from '../actions/cardspartnersActions'
import { ApiStatus, ICardspartnersItem } from '../models'

export const initialCardspartnersState: ICardspartnersState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  cardspartners: [],
  foundcardspartners: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function cardspartnersReducer(state: ICardspartnersState = initialCardspartnersState, action: CardspartnersAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case CardspartnersActionTypes.SEARCH_CARDSPARTNERS:
        draft.searchString = action.searchOptions.searchString
        break
      case CardspartnersActionTypes.SEARCHING_CARDSPARTNERS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case CardspartnersActionTypes.SEARCHING_CARDSPARTNERS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case CardspartnersActionTypes.FOUND_CARDSPARTNERS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep
          ? draft.foundcardspartners.push(...action.payload.cardspartners.docs)
          : (draft.foundcardspartners = action.payload.cardspartners.docs)
        draft.totalDocs = action.payload.cardspartners.totalDocs
        break

      case CardspartnersActionTypes.LOAD_CARDSPARTNERS:
      case CardspartnersActionTypes.LOADING_CARDSPARTNERS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundcardspartners = []
        break

      case CardspartnersActionTypes.LOADING_CARDSPARTNERS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case CardspartnersActionTypes.LOADED_CARDSPARTNERS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.cardspartners = action.payload.cardspartners.docs
        draft.totalDocs = action.payload.cardspartners.totalDocs
        break

      case CardspartnersActionTypes.ADD_CARDSPARTNERS:
      case CardspartnersActionTypes.ADDING_CARDSPARTNERS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case CardspartnersActionTypes.ADDING_CARDSPARTNERS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case CardspartnersActionTypes.ADDED_CARDSPARTNERS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.cardspartners.push(action.payload.cardspartners.docs[0])
        if (draft.searchString) draft.foundcardspartners.push(action.payload.cardspartners.docs[0])
        break

      case CardspartnersActionTypes.REMOVE_CARDPARTNERS:
        draft.cardspartners.splice(
          draft.cardspartners.findIndex((cardpartners) => cardpartners._id === action.payload._id),
          1
        )
        break

      case CardspartnersActionTypes.SOFT_REMOVE_CARDSPARTNERS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardspartnersActionTypes.SOFT_REMOVING_CARDSPARTNERS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardspartnersActionTypes.SOFT_REMOVED_CARDSPARTNERS:
        draft.addingStatus = ApiStatus.LOADED
        draft.cardspartners.splice(
          draft.cardspartners.findIndex((cardpartners) => cardpartners._id === action.payload._id),
          1
        )
        break

      case CardspartnersActionTypes.SOFT_REMOVING_CARDSPARTNERS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case CardspartnersActionTypes.EDIT_CARDSPARTNERS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case CardspartnersActionTypes.EDITING_CARDSPARTNERS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardspartnersActionTypes.EDITED_CARDSPARTNERS:
        draft.addingStatus = ApiStatus.LOADED
        draft.cardspartners[draft.cardspartners.findIndex((cardpartners) => cardpartners._id === action.payload._id)] = action.payload
        draft.foundcardspartners[draft.foundcardspartners.findIndex((cardpartners) => cardpartners._id === action.payload._id)] = action.payload
        break

      case CardspartnersActionTypes.EDITING_CARDSPARTNERS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface ICardspartnersState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  cardspartners: ICardspartnersItem[]
  foundcardspartners: ICardspartnersItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
